import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import withSizes from 'react-sizes';
import Swiper from 'react-id-swiper';
import { Tab, TabList, TabPanel } from 'react-tabs';
import { Accordion, Tabs } from "../../containers";
import { Clock, getAmenityName } from '../../utils';

import { AmenitiesSection, AmenitiesContainer, AmenitiesHeading, AmenitiesColumnContainer, AmenitiesColumn, AmenitiesColumnHeading, AmenitiesList, WorkingHours, WorkingHoursIcon } from "./styles";

const params = {
  slidesPerView: 'auto',
  freeMode: true,
  resistanceRatio : 0
};

const renderAmenitiesContent = (amenities, additionalAmenities, notMobile) => {
  let content;

  if (notMobile) {
    content = (
      <Fragment>
        <Tabs>
          <TabList>
            <Swiper
              {...params}
            >
              {amenities.map(child => <Tab key={getAmenityName(child.type).name}>{getAmenityName(child.type).icon}{getAmenityName(child.type).name}</Tab>)}
            </Swiper>
          </TabList>
          {amenities.map(child => {
            const {type, list, workingHours} = child;

            return (
              <TabPanel key={type}>
                <AmenitiesList twoColumn>
                  {list.map((feature, index) => (
                    <li key={feature + index} dangerouslySetInnerHTML={{__html: feature}} />
                  ))}
                </AmenitiesList>
                {workingHours && (
                  <WorkingHours>
                    <WorkingHoursIcon>
                      <Clock />
                    </WorkingHoursIcon>
                    <span>Hours:</span>
                    <b dangerouslySetInnerHTML={{ __html: workingHours }} />
                  </WorkingHours>
                )}
              </TabPanel>
            )
          })}
        </Tabs>
        {additionalAmenities && (
          <AmenitiesColumnContainer>
            {additionalAmenities.map(child => {
              if (child.list && child.list.length > 0) {
                return (
                  <AmenitiesColumn key={child.type}>
                    <AmenitiesColumnHeading>{getAmenityName(child.type).name}</AmenitiesColumnHeading>
                    <AmenitiesList as="div" dangerouslySetInnerHTML={{ __html: child.list }} />
                  </AmenitiesColumn>
                )
              }
              return null;
            })}
          </AmenitiesColumnContainer>
        )}
      </Fragment>
    )
  } else {
    content = <Accordion itemsList={amenities} additionalList={additionalAmenities} />;
  }

  return content;
};

const HotelAmenitiesSection = ({ amenities, additionalAmenities, notMobile }) => (
  <AmenitiesSection>
    <AmenitiesContainer>
      <AmenitiesHeading>Hotel Amenities</AmenitiesHeading>
      {renderAmenitiesContent(amenities, additionalAmenities, notMobile)}
    </AmenitiesContainer>
  </AmenitiesSection>
);

HotelAmenitiesSection.propTypes = {
  amenities: PropTypes.instanceOf(Array),
  additionalAmenities: PropTypes.instanceOf(Array),
  notMobile: PropTypes.bool,
};

const mapSizeToProps = ({ width }) => ({
  notMobile: width >= 768,
});

export default withSizes(mapSizeToProps)(HotelAmenitiesSection);
